var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-btn-group " + _vm.prefixCls + "-select-group")
  }, [_c('n3-button', {
    class: [(_vm.prefixCls + "-dropdown-toggle"), (_vm.prefixCls + "-select-btn"), _vm.showselected && _vm.multiple && _vm.value.length ? (_vm.prefixCls + "-select-multiple") : ''],
    style: ({
      width: _vm.width
    }),
    attrs: {
      "disabled": _vm.disabled,
      "size": _vm.size
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDropdown($event)
      }
    }
  }, [(_vm.showPlaceholder || !_vm.showselected) ? _c('span', [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.showselected) ? _c('span', [_vm._l((_vm.selectedItems), function(item) {
    return (_vm.multiple) ? [_c('render', {
      class: (_vm.prefixCls + "-selected-tag"),
      attrs: {
        "context": _vm.context || _vm.$parent._self,
        "template": _vm.format(item)
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.del(item)
        }
      }
    })] : [_c('render', {
      attrs: {
        "context": _vm.context || _vm.$parent._self,
        "template": _vm.format(_vm.selectedItems[0])
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), _c('n3-icon', {
    attrs: {
      "type": _vm.show ? 'angle-up' : 'angle-down'
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('ul', {
    directives: [{
      name: "n3-position",
      rawName: "v-n3-position",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "menu",
    class: (_vm.prefixCls + "-dropdown-menu"),
    style: ({
      maxHeight: _vm.menuMaxHeight,
      width: _vm.menuWidth
    })
  }, [(_vm.search) ? _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    class: (_vm.prefixCls + "-select-search"),
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addExtra($event)
      }
    }
  }), _vm._v(" "), (_vm.extra) ? _c('n3-icon', {
    attrs: {
      "type": "plus-square-o"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addExtra($event)
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('li', {
    class: (_vm.prefixCls + "-select-all")
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAll($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getL('all')) + "\n           "), _c('n3-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "check"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentOptions.length) ? _vm._l((_vm.filterOptions), function(option) {
    return _c('li', {
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "value": option.value
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(option)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(option.label)
      }
    }), _vm._v(" "), _c('n3-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.findIndex(option.value) !== -1),
        expression: "findIndex(option.value) !== -1"
      }],
      attrs: {
        "type": "check"
      }
    })], 1)])
  }) : _vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotify),
      expression: "showNotify"
    }],
    class: (_vm.prefixCls + "-notify"),
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("最多选择 " + _vm._s(_vm.limit) + " 项")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bcd7bd4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcd7bd4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Select/n3Select.vue
// module id = 654
// module chunks = 0 1